export default "__VITE_ASSET__DXaJ5zPi__"